import { useEffect, useRef } from "react";
import { download } from "./Utils";

type DownloadDocProps = {
  fileData: any;
};
export default function DownloadDoc(props: DownloadDocProps) {
  const { fileData } = props;
  const downloadingRef = useRef(false);

  useEffect(() => {
    if (fileData?.path && !downloadingRef.current) {
      downloadDoc();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileData]);

  /**
   *
   */
  const downloadDoc = () => {
    if (downloadingRef.current) return;
    
    downloadingRef.current = true;
    const token = localStorage.getItem("access_token");
    
    if (fileData?.path) {
      fetch(fileData?.path, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.blob())
        .then((response) => {
          download(
            response,
            fileData?.name || "",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          );
        })
        .catch((error) => {
          console.error("Download failed:", error);
        })
        .finally(() => {
          // Reset the flag after a short delay to allow for the download to complete
          setTimeout(() => {
            downloadingRef.current = false;
          }, 1000);
        });
    }
  };
  return <></>;
}
